<script lang="ts">
	import type { HTMLAttributes } from 'svelte/elements';

	const rest: HTMLAttributes<HTMLSpanElement> = $props();
</script>

<div role="status">
	<span aria-hidden="true" {...rest} class={['icon-[mdi--loading] animate-spin', rest.class]}
	></span>
	<span class="sr-only">Loading...</span>
</div>
